var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.analises && _vm.analises.length)?_c('div',{staticClass:"arrematante-analises"},[_c('h2',[_vm._v("Análises de Segurança")]),_vm._l((_vm.analises),function(analise){return _c('arrematante-analise-container',{key:analise.id,attrs:{"analise":analise}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }